import styled from 'styled-components'

export const FormErrorsBox = styled.div`
  border: 2px solid ${({ theme }) => theme.colors.danger};
  border-radius: 12px;
  padding: 12px 16px;
  margin: 10px 14px;
  background: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(239, 68, 68, 0.1)' : 'rgba(239, 68, 68, 0.06)')};

  ul {
    margin: 4px 0 0;
    padding-left: 20px;
  }

  li {
    color: ${({ theme }) => theme.colors.danger};
    font-size: 14px;
  }
`
